<template>
    <div>
        <label :for="id" v-if="!!label"
            >{{ label }}
            <span v-if="!!required" class="field-required-mark">*</span></label
        >
        <b-form-input
            type="time"
            v-bind="$attrs"
            v-on="$listeners"
            :state="isValid"
        ></b-form-input>
        <span v-if="hasError && !!errorMessage" class="field-error">{{
            errorMessage
        }}</span>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
        },
        id: {
            type: String,
            default: () => `date-${parseInt(Math.random() * 10000000000)}`,
        },
        hasError: {
            type: Boolean,
            default: () => false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: () => false,
        },
    },
    computed: {
        isValid() {
            return this.hasError ? false : null
        },
    },
}
</script>
